// extracted by mini-css-extract-plugin
module.exports = {"container":"TableRowsSkeleton_container__18Cz9","gradientAnim":"TableRowsSkeleton_gradientAnim__3c9Qq","bordered":"TableRowsSkeleton_bordered__3om2Q"};